import Performances from "pages/dashboard/shared/Performances/Performances";
import React from "react";

const AdminPerformances = () => {
  return <Performances />;
};

export default AdminPerformances;
